import { LanguageRegion } from './gen/i18n/v3/language_regions_pb';

/**
 * Converts a browser locale string to the corresponding LanguageRegion enum value.
 * If no match is found, it defaults to EN_US.
 */
export function convertBrowserLocaleToLanguageRegion(locale: string): LanguageRegion {
  if (!locale) {
    return LanguageRegion.EN_US;
  }

  // Normalize the locale string to match our enum format
  const normalizedLocale = locale.replace('-', '_').toUpperCase();
  
  // Try to find a direct match in the enum
  const enumKey = `LANGUAGE_REGION_${normalizedLocale}` as keyof typeof LanguageRegion;
  if (LanguageRegion[enumKey] !== undefined) {
    return LanguageRegion[enumKey];
  }

  // Map of specific region codes to their corresponding LanguageRegion values
  const regionMap: Record<string, LanguageRegion> = {
    'EN_GB': LanguageRegion.EN_GB,
    'EN_CA': LanguageRegion.EN_CA,
    'EN_AU': LanguageRegion.EN_AU,
    'EN_IN': LanguageRegion.EN_IN,
    'ZH_TW': LanguageRegion.ZH_TW,
    'ZH_HK': LanguageRegion.ZH_HK,
    'ZH_SG': LanguageRegion.ZH_SG,
    'DE_AT': LanguageRegion.DE_AT,
    'DE_CH': LanguageRegion.DE_CH,
    'DE_LU': LanguageRegion.DE_LU,
    'ES_MX': LanguageRegion.ES_MX,
    'ES_AR': LanguageRegion.ES_AR,
    'ES_CO': LanguageRegion.ES_CO,
    'FR_CA': LanguageRegion.FR_CA,
    'FR_BE': LanguageRegion.FR_BE,
    'FR_CH': LanguageRegion.FR_CH,
    'PT_PT': LanguageRegion.PT_PT,
    'LEET': LanguageRegion.LEET,
    'leet': LanguageRegion.LEET,
  };

  // Check if we have a specific region mapping
  if (regionMap[normalizedLocale]) {
    return regionMap[normalizedLocale];
  }

  // If no direct match, try to match just the language part
  const languagePart = normalizedLocale.split('_')[0] || '';
  
  // Map of language codes to their default regions
  const defaultRegions: Record<string, LanguageRegion> = {
    'EN': LanguageRegion.EN_US,
    'ZH': LanguageRegion.ZH_CN,
    'DE': LanguageRegion.DE_DE,
    'ES': LanguageRegion.ES_ES,
    'FR': LanguageRegion.FR_FR,
    'JA': LanguageRegion.JA_JP,
    'KO': LanguageRegion.KO_KR,
    'RU': LanguageRegion.RU_RU,
    'PT': LanguageRegion.PT_BR,
    'AR': LanguageRegion.AR_SA,
    'HI': LanguageRegion.HI_IN,
    'IT': LanguageRegion.IT_IT,
    'NL': LanguageRegion.NL_NL,
    'SV': LanguageRegion.SV_SE,
  };

  // Return the default region for the language if it exists
  return defaultRegions[languagePart] || LanguageRegion.EN_US;
}
